import { Button as MuiButton } from '@material-ui/core'
import React from 'react'

import constants from 'app/constants'
import { eventAlert } from 'app/helpers'

/**
 * Column options that draw the parent's own pay-now link, so the team can read
 * it out or paste it if the WhatsApp message did not reach them (owner,
 * 2026-10-16). It is the same link as the "Pay now" button on the payment-link
 * message.
 */
export const payLinkOptions = {
  customBodyRender: (url, meta) =>
    url && meta.rowData ? (
      <span style={{ whiteSpace: 'nowrap' }}>
        <a href={url} target="_blank" rel="noopener noreferrer">
          {url.replace(/^https?:\/\//, '')}
        </a>{' '}
        <MuiButton
          size="small"
          onClick={() => {
            navigator.clipboard.writeText(url)
            eventAlert('Payment link copied', constants.SUCCESS)
          }}
        >
          copy
        </MuiButton>
      </span>
    ) : (
      '—'
    )
}
